module.exports = __webpack_public_path__ + "static/media/reactLogo.5d5d9eef.svg";